export default {
    "admin.pages.kjxy.xy.list.title": "小院列表",
    "admin.pages.kjxy.xy.edit.title": "编辑小院",
    "admin.pages.kjxy.team.category.title": "科技团队分类",
    "admin.pages.kjxy.team.category.edit.title": "编辑科技团队分类",
    "admin.pages.kjxy.team.edit.title": "编辑专家信息",
    "admin.pages.kjxy.team.list.title": "科技专家团队",
    "admin.pages.kjxy.news.list.title": "最新动态列表",
    "admin.pages.kjxy.news.edit.title": "编辑最新动态",
    "admin.pages.kjxy.student.list.title": "入驻同学列表",
    "admin.pages.kjxy.student.edit.title": "编辑入驻同学",
    "admin.pages.kjxy.goods.store.list.title": "农产品库",
    "admin.pages.kjxy.goods.store.edit.title": "编辑农产品库",
    "admin.pages.kjxy.expert.apply.list.title": "科技小院专家需求申请表",
    "admin.pages.kjxy.teacher.list.title": "小院导师",
    "admin.pages.kjxy.teacher.edit.title": "编辑小院导师",
    "admin.pages.kjxy.singledoc.title": "编辑文章内容",
    "admin.pages.kjxy.aboutUs.title": "编辑联系我们文章",
    "admin.pages.kjxy.xydesc.title": "编辑小院介绍",
    "admin.pages.kjxy.xydesc.review.title": "小院介绍"
};